import { getRandomElements } from "../shared/util";

export function getDistractors(position, morpheme) {
  const arr = morphWords[position];

  // should have a different morpheme to be a distractor
  const pool = arr.filter((w) => !w.includes(morpheme));
  return getRandomElements(pool, 2);
}

const morphWords = {
  prefix: [
    "anticrime",
    "antiseptic",
    "astronaut",
    "astronomer",
    "bicycle",
    "bilateral",
    "copilot",
    "committee",
    "community",
    "concur",
    "concert",
    "copilot",
    "cooperate",
    "defrost",
    "dethrone",
  ],
  root: [
    "anarchist",
    "anarchy",
    "catalog",
    "catalyst",
    "clause",
    "claustrophobic",
    "cloister",
    "closure",
    "conclusion",
    "conclusive",
    "contort",
    "contradict",
    "contrary",
    "controversial",
    "controversy",
    "counterfeit",
    "counterpart",
    "credible",
    "describe",
    "different",
    "exclude",
    "ignorant",
    "grieve",
    "tortuous",
  ],
  suffix: [
    "biology",
    "childhood",
    "disrupt",
    "ecology",
    "faster",
    "foolish",
    "happiness",
    "honorable",
    "hopeless",
    "leadership",
    "magician",
    "nervous",
    "nicely",
    "operator",
    "pianist",
    "statehood",
    "teacher",
    "toaster",
    "transport",
    "visible",
    "wonderful",
  ],
};
